// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.RentalManagerUserPropertyMultiplexWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyMultiplexWebApiHandler_create,
  RentalManagerUserPropertyMultiplexWebApiHandler_details,
  RentalManagerUserPropertyMultiplexWebApiHandler_details_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers,
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_overview,
  RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria,
  RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished,
  RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_update,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingAlias,
  UserPropertyMultiplexCreateUnitsRequestWebDto,
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  UserPropertyMultiplexSetListingCriteriaRequestWebDto,
  UserPropertyMultiplexSetListingCriteriaResponseWebDto,
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  UserPropertyMultiplexUpdateRequestWebDto,
  UserPropertyMultiplexUpdateResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface DetailsParams {
  multiplexBuildingSessionId: string;
}
interface GetUnitNumbersParams {
  fullAddress: string;
}
interface OverviewParams {
  multiplexBuildingSessionId: string;
}
interface UnitPublishedParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId: string;
}

export interface RentalManagerUserPropertyMultiplexWebApiHandler_create_Args {
  postData: UserPropertyMultiplexCreateUnitsRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_create_Args
>;

/**
 * Create units for a multiplex
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_create_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_create(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyMultiplexWebApiHandler_details_Options = UseQueryOptions<
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  unknown,
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get property details for a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_details.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_details_GetKey;

export type RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Options = UseQueryOptions<
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  unknown,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  readonly [string, GetUnitNumbersParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey = (getParams: GetUnitNumbersParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_queryOptions = (
  getParams: GetUnitNumbersParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get unit numbers for a multiplex
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers = (
  getParams: GetUnitNumbersParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey;

export type RentalManagerUserPropertyMultiplexWebApiHandler_overview_Options = UseQueryOptions<
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  unknown,
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  readonly [string, OverviewParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_overview_GetKey = (getParams: OverviewParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_overview_queryOptions = (
  getParams: OverviewParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_overview_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_overview(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get overview for a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_overview = (
  getParams: OverviewParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_overview_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_overview.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_overview_GetKey;

export interface RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Args {
  postData: UserPropertyMultiplexSetListingCriteriaRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Options = UseMutationOptions<
  UserPropertyMultiplexSetListingCriteriaResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Args
>;

/**
 * Set listing criteria for all the units in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_setListingCriteria(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Options = UseQueryOptions<
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  unknown,
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  readonly [string, UnitPublishedParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_GetKey = (getParams: UnitPublishedParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_queryOptions = (
  getParams: UnitPublishedParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get publish summary after a multiplex unit is published
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished = (
  getParams: UnitPublishedParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_GetKey;

export interface RentalManagerUserPropertyMultiplexWebApiHandler_update_Args {
  postData: UserPropertyMultiplexUpdateRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_update_Options = UseMutationOptions<
  UserPropertyMultiplexUpdateResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_update_Args
>;

/**
 * Update listing fields for all the units in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_update_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_update_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_update(args.postData, httpClient),
  });
};
